import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { encodeSearchParams } from '@/utils/index'


import QS from 'qs'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 1000 * 60 * 1 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['X-Token'] = getToken()
    } // transform post data to queryString
    if(!config.params){
      config.params = {}
    }
    config.params.token = localStorage.getItem('usertoken') 
    config.params.userid = localStorage.getItem('userid')

    if (config.method === 'post' && config.headers['Content-Type'] === 'multipart/form-data') {
      config.data = Qs.stringify(config.data)
    }
    // if(isRedirect && config.url.includes(serviceURL)) { // 陕西宝鸡水文移动应用微信小程序实现后台转发
    //   if (config.method === 'get' ) { 
    //     config.params.url = config.url.replace(serviceURL,serviceIp)//对代理的特殊处理，还原参数地址 serviceIp  ,对转发地址的特殊处理，转发地址也需要代理
    //     if(config.params.conQuery && (typeof config.params.conQuery === 'string') ) config.params.conQuery = encodeURIComponent(config.params.conQuery);// encodeURIComponent(config.params.conQuery)//为数组时
    //     config.url = jsvaIPIURL +"hto/doGet";// "/wxxcx//hto/doGet";// "http://192.168.3.47:15101/http/doGet";//?url="+config.url//+"&params="+JSON.stringify(config.params)
    //     config.method = 'post' // 防止url过长
    //   }else { 
    //     if(!config.params) config.params = {}
    //     config.params.url = config.url.replace(serviceURL,serviceIp)
    //     config.params["Content-Type"] = config.headers['Content-Type'];
    //     if(config.data && (typeof config.data === 'string') ) config.data = encodeURIComponent(config.data);
    //     config.url = jsvaIPIURL +"hto/doPost";//
    //   }
    // }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = (typeof response.data === 'string') ? ( response.data == '' ? {} : JSON.parse(response.data)) :response.data; // 陕西宝鸡水文移动应用微信小程序实现后台转发
    // if the custom code is not 20000, it is judged as an error.
    if (response.status !== 200) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      // // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      // if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      //   // to re-login
      //   MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
      //     confirmButtonText: 'Re-Login',
      //     cancelButtonText: 'Cancel',
      //     type: 'warning'
      //   }).then(() => {
      //     store.dispatch('user/resetToken').then(() => {
      //       location.reload()
      //     })
      //   })
      // }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
